export default __webpack_public_path__ + "static/media/link-arrow--dark.71fae239.svg";